import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { UmsService } from '../ums.service';


@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent implements OnInit {
  constructor(
    private spinner: NgxSpinnerService,
  public umsService: UmsService) { }
    src;
  src1;
  pdfSrc;
fileType = "";
isImage = false;
  ispdf= false;
  noDataaa= false;
  showBtn = false;
  rotation = 0;
  zoom = 1;
  page = 1;
  totalPages = 0;
  fileData: string = '';
  filePath: string = '';
  ngOnInit(): void {

this.filePath = sessionStorage.getItem('filePath') || '';
this.umsService.fetchDocument({ filePath: this.filePath }).subscribe((res) => {
      if (res.status) {
            this.fileData = res.doc
       }

  if (!this.fileData) {
    this.noDataaa = true;
    this.ispdf = false;
    this.isImage = false;
    this.showBtn = false;
    return;   
  }

  this.src = this.fileData;
  this.noDataaa = false;
  this.showBtn = true;
  if (this.src.startsWith('data:image')) {
    this.isImage = true;
    this.ispdf = false;
  } else {
    this.isImage = false;
    this.ispdf = true;
  }
    });
}
    // ngOnInit(): void {

    // // Retrieve PDF from sessionStorage
    // this.fileData = sessionStorage.getItem('pdfData') || '';
    //   this.src = this.fileData
    //   if(this.src == undefined || this.src == ''){
    //     this.noDataaa = true;
    //     this.ispdf = false;
    //    this.isImage = false;
    //    this.showBtn=false;
    //   }
    //   if (this.src.startsWith('data:image')) {
    //     this.isImage = true;
    //     this.ispdf = false;
    //     this.noDataaa = false;
    //     this.showBtn = true
    //   }
    //   else { 
    //     this.isImage = false;
    //     this.noDataaa = false;
    //     this.ispdf = true;
    //     this.showBtn = true
    //     // this.src = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
    //     // this.src1 = 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf';
    //   }
    
    // }
rotate() {
    this.rotation = (this.rotation + 90) % 360;
  }

  rotateAntiClockwise() {
    this.rotation = (this.rotation - 90) % 360;
    if (this.rotation < 0) this.rotation += 360;
  }

  zoomIn() {
    this.zoom += 0.25;
  }

  zoomOut() {
    this.zoom = Math.max(0.5, this.zoom - 0.25);
  }

  resetView() {
    this.rotation = 0;
    this.zoom = 1;
    this.page = 1;
  }

  onPdfLoad(pdf: any) {
    this.totalPages = pdf.numPages;
  }

  previousPage() {
    if (this.page > 1) {
      this.page--;
    }
  }

  nextPage() {
    if (this.page < this.totalPages) {
      this.page++;
    }
  }
 dowload()
    {
      const link=document.createElement("a");
       link.href=this.src;
       link.download='Download';
       link.click()
    }

    close() {
  window.close();
}
  
}
